<template>
  <v-card-text class="details">
    <div class="details__row" v-for="(value, key) in documentsInfo" :key="key" v-show="value">
      <div class="details__cell details__cell--key">{{ key }}:</div>
      <div class="details__cell details__cell--value">
        <span v-if="key === 'Upload Date'">
          {{
          value | moment("MMMM D YYYY")
          }}
        </span>
        <span v-else-if="Array.isArray(value)">
          <template v-if="value.length > 0">
            <div v-for="item in value" :key="item.id">{{ item.name }}</div>
          </template>
          <div v-else>None</div>
        </span>
        <span v-else>{{ value }}</span>
      </div>
    </div>
  </v-card-text>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dataPoints: {
        "Display Name": "display_name",
        "File Type": "file_ext",
        "File Size": "file_size",
        Categories: "categories",
        "Permission Groups": "permission_groups",
        "Upload Date": "created_at"
        // "File Name": "file_name",
        // "File Path": "full_path",
        // ID: "id"
      }
    };
  },

  props: {
    id: {
      default: null
    },

    document: {
      default: false
    }
  },

  computed: {
    documentsInfo() {
      let data = {};

      _.forEach(this.dataPoints, (fieldKey, key) => {
        let value = this.getObjectValue(fieldKey, this.document);

        if (fieldKey === "permission_groups") {
          value = (value || []).map(({ name, description, id }) => ({
            id,
            name: `${name} - ${description}`
          }));
        }

        data[key] = value;
      });

      return data;
    }
  }
};
</script>
